import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function WomenWhoHeal() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Women Who Heal | MANDIE OZEE.";
  }, []);

  return (
    <div className="min-h-screen bg-[#1A1A1A] flex flex-col items-center justify-center px-4 py-24">
      <div className="text-center max-w-xl">
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4">
          Coming Soon
        </p>
        <h1 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] mb-4">
          Women Who Heal
        </h1>
        <p className="font-body text-sm md:text-base text-[#E8E8E8] mb-8">
          The Women Who Heal conference page is coming soon. Full event details, schedule, and waitlist will be here.
        </p>
        <button
          onClick={() => navigate("/")}
          className="inline-flex items-center justify-center px-6 py-3 bg-[#D4006A] text-white text-sm font-body font-medium rounded-full hover:bg-[#B3005A] transition-colors duration-300"
        >
          Back to Home
        </button>
      </div>
    </div>
  );
}